import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Detail, MovableCardWrapper } from '../../../../../lifecycleDesigner/drive/Activity/styles/Base'
import ActivityCard from './../../../cards/ActivityCardNew'
class Card extends Component {
	removeCard = e => {
		const { id, laneId, removeCard, onDelete } = this.props
		removeCard(laneId, id)
		onDelete(id, laneId)
		e.stopPropagation()
	}

	renderBody = () => {
		if (this.props.customCardLayout) {
			const { customCard, ...otherProps } = this.props
			return React.cloneElement(customCard, { ...otherProps })
		} else {
			const { title } = this.props
			return (
				<span title="">
					<Detail>{title}</Detail>
				</span>
			)
		}
	}

	render() {

		const { id, cardStyle, editable, hideCardDeleteIcon, customCardLayout, dragStyle, activeTab, selectedActivityData, activityRACIUsers, selectedDataById, card, setUniqueId, ...otherProps } = this.props
		const style = customCardLayout ? { ...cardStyle, padding: 0 } : cardStyle

		return (
			<MovableCardWrapper
				key={id}
				data-id={id}
				style={{
					...style,
					...dragStyle
				}}
				{...otherProps}
				title=""
			>

				<ActivityCard
					type="activity"
					activityData={card}
					activeTab={activeTab}
					selectedActivityData={this.props.selectedActivityData}
					activityRACIUsers={this.props.activityRACIUsers}
					selectedDataById={this.props.selectedDataById}
					selectedOrganisation={this.props.selectedOrganisation}
					index={this.props.index}
					user={this.props.user}
					setUniqueId={this.props.setUniqueId}
					loadingUpdateInitiativeActivities={this.props.loadingUpdateInitiativeActivities}
					loadingUpdateMemberActivities={this.props.loadingUpdateMemberActivities}
					currentOrganization={this.props.currentOrganization}
				/>

			</MovableCardWrapper>
		)
	}
}

Card.defaultProps = {
	cardStyle: {},
	customCardLayout: false,
	onDelete: () => { },
	editable: false,
	dragStyle: {}
}

Card.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string,
	index: PropTypes.number,
	description: PropTypes.string,
	label: PropTypes.string,
	tags: PropTypes.array,
	laneId: PropTypes.string.isRequired,
	removeCard: PropTypes.func,
	onClick: PropTypes.func,
	onDelete: PropTypes.func,
	metadata: PropTypes.object,
	cardStyle: PropTypes.object,
	dragStyle: PropTypes.object,
	tagStyle: PropTypes.object,
	customCardLayout: PropTypes.bool,
	customCard: PropTypes.node,
	editable: PropTypes.bool
}

export default Card